import React, { useState, useEffect } from 'react'
import { NavigationContext } from '../NavigationContext'

function Aktuelles() {
  const [currentPosts, setCurrentPosts] = useState([])
  const [pastPosts, setPastPosts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const categoryResponse = await fetch('/wp-json/wp/v2/categories?slug=aktuelles')
        const categoryData = await categoryResponse.json()
        
        if (categoryData.length > 0) {
          const aktuellesId = categoryData[0].id
          const response = await fetch(`/wp-json/wp/v2/posts?categories=${aktuellesId}&_fields=id,title,content,acf,slug`)
          const data = await response.json()

          const decodeHTML = (html) => {
            const txt = document.createElement('textarea')
            txt.innerHTML = html
            return txt.value
          }

          const today = new Date()
          const sortedPosts = data.map(post => ({
            id: post.id,
            title: decodeHTML(post.title.rendered),
            content: post.content.rendered,
            dateFrom: post.acf?.date_from || '',
            dateTo: post.acf?.date_to || '',
            externalLink: post.acf?.external_link || '',
            documentPdf: post.acf?.document_pdf || '',
            slug: post.slug,
            date: new Date(post.acf?.date_from.split('.').reverse().join('-'))
          })).sort((a, b) => b.date - a.date)

          const { current, past } = sortedPosts.reduce((acc, post) => {
            if (post.date >= today) {
              acc.current.push(post)
            } else {
              acc.past.push(post)
            }
            return acc
          }, { current: [], past: [] })

          setCurrentPosts(current)
          setPastPosts(past)
        }
      } catch (error) {
        console.error('Error fetching posts:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchPosts()
  }, [])

  return (
    <main className="aktuelles-page">
      <h1 className="page-title">Aktuelles</h1>
      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <>
          <div className="posts-grid current-posts">
            {currentPosts.map(post => (
              <article key={post.id} className="press-post">
                <div className="title-date-wrapper">
                  <div className="post-date">
                    {post.dateFrom}
                    {post.dateTo && ` - ${post.dateTo}`}
                  </div>
                  <div className="title-links-wrapper">
                    <h3>{post.title}</h3>
                    <div className="post-content">
                      <div 
                        className="post-excerpt"
                        dangerouslySetInnerHTML={{ __html: post.content }}
                      />
                    </div>
                    <div className="post-links">
                      {post.externalLink && (
                        <a 
                          href={post.externalLink} 
                          target="_blank" 
                          rel="noopener noreferrer"
                        >
                          Link zur Website ↪
                        </a>
                      )}
                      {post.documentPdf && (
                        <a 
                          href={post.documentPdf} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Dokument herunterladen
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </article>            ))}
          </div>
          
          {pastPosts.length > 0 && (
            <>
              <h2 className="section-title">Vergangenes</h2>
              <div className="posts-grid past-posts">
                {pastPosts.map(post => (
                  <article key={post.id} className="press-post">
                    <div className="title-date-wrapper">
                      <div className="post-date">
                        {post.dateFrom}
                        {post.dateTo && ` - ${post.dateTo}`}
                      </div>
                      <div className="title-links-wrapper">
                        <h3>{post.title}</h3>
                        <div className="post-content">
                          <div 
                            className="post-excerpt"
                            dangerouslySetInnerHTML={{ __html: post.content }}
                          />
                        </div>
                        <div className="post-links">
                          {post.externalLink && (
                            <a 
                              href={post.externalLink} 
                              target="_blank" 
                              rel="noopener noreferrer"
                            >
                              Link zur Website ↪
                            </a>
                          )}
                          {post.documentPdf && (
                            <a 
                              href={post.documentPdf} 
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Dokument herunterladen
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </main>
  )
}

export default Aktuelles